import { Callout } from "@octopusdeploy/design-system-components";
import ExternalLink from "../../../components/Navigation/ExternalLink";
import externalSystemLinks from "../../../externalSystemLinks";
import * as React from "react";
import {InstanceLimitResource} from "../../../client/resources/instanceLimitResource";

export function WarnToCancelViaBillingAlert({ action, instanceLimit }: { action: string, instanceLimit: InstanceLimitResource }) {
    if (!!instanceLimit.CloudSubscriptionId) {
        return <div>
            <Callout title="This Instance has a valid Cloud Subscription" type="danger">
                You should <em>Cancel</em> it via <ExternalLink
                href={externalSystemLinks.billing.subscriptionDetails(instanceLimit)}>Billing Administration</ExternalLink>.
                If you {action} it here Billing and Cloud Portal will be out of sync. <ExternalLink
                href="https://github.com/OctopusDeploy/hosted-docs/blob/main/how-to/delete-a-cloud-instance.md">More
                info</ExternalLink>.
            </Callout>
        </div>
    }
    return null;
}

export function WarnToReactivateViaBillingAlert({ action, instanceLimit }: { action: string, instanceLimit: InstanceLimitResource }) {
    if (!!instanceLimit.CloudSubscriptionId) {
        return <div>
            <Callout title="This Instance has a valid Cloud Subscription" type="danger">
                You should extend the subscription's term via <ExternalLink
                href={externalSystemLinks.billing.subscriptionDetails(instanceLimit)}>Billing Administration</ExternalLink>.
                If you {action} it here Billing and Cloud Portal will be out of sync. <ExternalLink
                href="https://github.com/OctopusDeploy/hosted-docs/blob/main/how-to/reactivate-a-cloud-instance.md">More
                info</ExternalLink>.
            </Callout>
        </div>
    }
    return null;
}
